import { JSX } from 'react';
import { checkDatasourceForRendering } from 'src/shared/checkDatasourceForRendering';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { ReverseRow } from '@ahc-digital/component-library';
import { CreateReverseRowStoryWithVisualModel } from './C11ReverseRowStoryWithVisual.service';
import { C11ReverseRowStoryWithVisualProps } from './C11ReverseRowStoryWithVisual.types';

const Default = (props?: C11ReverseRowStoryWithVisualProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  return (
    <ReverseRow
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateReverseRowStoryWithVisualModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C11ReverseRowStoryWithVisualProps>(Default);
